/**
 * Get the first visible section id
 * @param sections - The sections
 * @param headerOffset - The header offset
 * @returns The first visible section id
 */
const getFirstVisibleSectionId = (sections, headerOffset) => {
  const sectionsInView = sections.filter((section) => {
    const sectionElement = document.getElementById(`${section.id}-section`);

    if (!sectionElement) {
      return false;
    }
    const sectionRect = sectionElement.getBoundingClientRect();
    return (
      sectionRect.top <= window.innerHeight &&
      sectionRect.bottom >= headerOffset
    );
  });

  if (sectionsInView.length > 0) {
    return sectionsInView[0].id;
  }

  return null;
};

export default getFirstVisibleSectionId;
